import ActionType from 'actions/ActionType'

export default (state = null, action) => {
  switch (action.type) {
    case ActionType.Inbox.SELECT_CONTACT:
      return action.payload
    case ActionType.Email.SEND_REQUEST:
      return null
    case ActionType.Inbox.SEND_SMS:
      return null
    case ActionType.Inbox.SELECT_CONVERSATION:
      return null
    // case ActionType.Inbox.LIST_SUCCESS:
    //   if (action.payload) {
    //     const obj = action.payload.reduce((acc, el) => {
    //       if (el.contact_id) {
    //         acc[el.contact_id] = true
    //       }
    //       return acc
    //     }, {})

    //     if (state && state.id && obj[state.id]) {
    //       return null
    //     }
    //   }
    //   return state

    // case ActionType.Inbox.CONTACT_SEARCH:
    //   if (action.payload === null) return null
    //   return state
    default:
      return state
  }
}
